var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-25",class:_vm.side === 'left' ? 'left-panel' : 'right-panel'},[_c('div',{staticClass:"absolute h-6 w-20 top-0",class:[
            _vm.statusClasses,
            _vm.side === 'left' ? 'left-0' : 'right-0'
        ]}),_vm._v(" "),_c('div',{staticClass:"absolute h-full w-6",class:[
            _vm.statusClasses,
            _vm.side === 'left' ? 'inset-0' : 'ml-auto inset-0'
        ]}),_vm._v(" "),_c('div',{staticClass:"absolute bottom-0 h-6 w-20",class:[
            _vm.statusClasses,
            _vm.side === 'left' ? 'left-0' : 'right-0'
        ]})])
}
var staticRenderFns = []

export { render, staticRenderFns }